<template>
  <div>
    <h3 class="mb-2">Reference <span class="text-sm font-normal">(optional)</span></h3>
    <p class="text-xs mb-2">Name your print order item for your own reference.</p>
    <input type="text" id="customer_reference" v-model="orderItem.customer_reference" class="mb-8 input w-full bg-white text-grey-darkest" :class="{'md:w-2/3': fullWidth}">
  </div>
</template>
<script>
export default {
  props: ['orderItem', 'fullWidth']
}
</script>
